import { WMRateScheduleDpLookupLayout, WMCodesLookupLayout, WMChargeCodeLookupLayout } from "../../../../common/lookups/Layouts/WMLayouts";
import { IDCustomerLookupLayout } from "../../../../common/lookups/Layouts/IdLayouts";
import { ABPopupMessageLayout } from "../../../../common/lookups/Layouts/ABLayouts";

const classCodes = WMCodesLookupLayout({ codeType: '28' });
const subClassCodes = WMCodesLookupLayout({ codeType: '29' });

export const SearchLayout = [
    {
        "groupId": 1,
        "fields": [
            { "name": "scheduleCode", "tableName": "WMRATESCHEDULEHEADER", "label": "Code", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "description", "tableName": "WMRATESCHEDULEHEADER", "label": "Description", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "scheduleType", "tableName": "WMRATESCHEDULEHEADER", "label": "Type", "type": "text", "required": false, "visible": true, "isLabelChanged": false }
        ]
    },
    {
        "groupId": 2,
        "fields": [
            { "name": "status", "tableName": "WMRATESCHEDULEHEADER", "label": "Status", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "scheduleApply", "tableName": "WMRATESCHEDULEHEADER", "label": "Apply", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "effectiveDate", "tableName": "WMRATESCHEDULEHEADER", "label": "Effective Date", "type": "date", "required": false, "visible": true, "isLabelChanged": false }
        ]
    },
    {
        "groupId": 3,
        "fields": [
            { "name": "record", "tableName": "WMRATESCHEDULEHEADER", "label": "Record#", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "customerName", "tableName": "WMRATESCHEDULEHEADER", "label": "Name", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "itemClass", "tableName": "WMRATESCHEDULEHEADER", "label": "Item Class", "type": "text", "required": false, "visible": true, "isLabelChanged": false }
        ]
    },
    {
        "groupId": 4,
        "fields": [
            { "name": "itemSubClass", "tableName": "WMRATESCHEDULEHEADER", "label": "Item Sub Class", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "storageFrequency", "tableName": "WMRATESCHEDULEHEADER", "label": "Frequency", "type": "text", "required": false, "visible": true, "isLabelChanged": false }
        ]
    },
    {
        "groupId": 5,
        "fields": [
            { "name": "userDefinedCode1", "tableName": "WMRATESCHEDULEHEADER", "label": "Code 1", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "userDefinedCode2", "tableName": "WMRATESCHEDULEHEADER", "label": "Code 2", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "userDefinedCode3", "tableName": "WMRATESCHEDULEHEADER", "label": "Code 3", "type": "text", "required": false, "visible": true, "isLabelChanged": false }
        ]
    },
    {
        "groupId": 6,
        "fields": [
            { "name": "userDefinedCode4", "tableName": "WMRATESCHEDULEHEADER", "label": "Code 4", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "userDefinedCode5", "tableName": "WMRATESCHEDULEHEADER", "label": "Code 5", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "userDefinedCode6", "tableName": "WMRATESCHEDULEHEADER", "label": "Code 6", "type": "text", "required": false, "visible": true, "isLabelChanged": false }
        ]
    },
    {
        "groupId": 7,
        "fields": [
            { "name": "userDefinedCode7", "tableName": "WMRATESCHEDULEHEADER", "label": "Code 7", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "userDefinedCode8", "tableName": "WMRATESCHEDULEHEADER", "label": "Code 8", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "userDefinedCode9", "tableName": "WMRATESCHEDULEHEADER", "label": "Code 9", "type": "text", "required": false, "visible": true, "isLabelChanged": false }
        ]
    },
    {
        "groupId": 8,
        "fields": [
            { "name": "userDefinedCode10", "tableName": "WMRATESCHEDULEHEADER", "label": "Code 10", "type": "text", "required": false, "visible": true, "isLabelChanged": false }
        ]
    },
    {
        "groupId": 9,
        "fields": [
            { "name": "userDefinedDate1", "tableName": "WMRATESCHEDULEHEADER", "label": "Date 1", "type": "date", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "userDefinedDate2", "tableName": "WMRATESCHEDULEHEADER", "label": "Date 2", "type": "date", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "userDefinedDate3", "tableName": "WMRATESCHEDULEHEADER", "label": "Date 3", "type": "date", "required": false, "visible": true, "isLabelChanged": false }
        ]
    },
    {
        "groupId": 10,
        "fields": [
            { "name": "userDefinedDate4", "tableName": "WMRATESCHEDULEHEADER", "label": "Date 4", "type": "date", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "userDefinedDate5", "tableName": "WMRATESCHEDULEHEADER", "label": "Date 5", "type": "date", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "userDefinedDate6", "tableName": "WMRATESCHEDULEHEADER", "label": "Date 6", "type": "date", "required": false, "visible": true, "isLabelChanged": false }
        ]
    },
    {
        "groupId": 11,
        "fields": [
            { "name": "userDefinedDate7", "tableName": "WMRATESCHEDULEHEADER", "label": "Date 7", "type": "date", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "userDefinedDate8", "tableName": "WMRATESCHEDULEHEADER", "label": "Date 8", "type": "date", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "userDefinedDate9", "tableName": "WMRATESCHEDULEHEADER", "label": "Date 9", "type": "date", "required": false, "visible": true, "isLabelChanged": false }
        ]
    },
    {
        "groupId": 12,
        "fields": [
            { "name": "userDefinedDate10", "tableName": "WMRATESCHEDULEHEADER", "label": "Date 10", "type": "date", "required": false, "visible": true, "isLabelChanged": false }
        ]
    },
    {
        "groupId": 13,
        "fields": [
            { "name": "userDefinedQuantity1", "tableName": "WMRATESCHEDULEHEADER", "label": "Quantity 1", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "userDefinedQuantity2", "tableName": "WMRATESCHEDULEHEADER", "label": "Quantity 2", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "userDefinedQuantity3", "tableName": "WMRATESCHEDULEHEADER", "label": "Quantity 3", "type": "text", "required": false, "visible": true, "isLabelChanged": false }
        ]
    },
    {
        "groupId": 14,
        "fields": [
            { "name": "userDefinedQuantity4", "tableName": "WMRATESCHEDULEHEADER", "label": "Quantity 4", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "userDefinedQuantity5", "tableName": "WMRATESCHEDULEHEADER", "label": "Quantity 5", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "userDefinedQuantity6", "tableName": "WMRATESCHEDULEHEADER", "label": "Quantity 6", "type": "text", "required": false, "visible": true, "isLabelChanged": false }
        ]
    },
    {
        "groupId": 15,
        "fields": [
            { "name": "userDefinedQuantity7", "tableName": "WMRATESCHEDULEHEADER", "label": "Quantity 7", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "userDefinedQuantity8", "tableName": "WMRATESCHEDULEHEADER", "label": "Quantity 8", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "userDefinedQuantity9", "tableName": "WMRATESCHEDULEHEADER", "label": "Quantity 9", "type": "text", "required": false, "visible": true, "isLabelChanged": false }
        ]
    },
    {
        "groupId": 16,
        "fields": [
            { "name": "userDefinedQuantity10", "tableName": "WMRATESCHEDULEHEADER", "label": "Quantity 10", "type": "text", "required": false, "visible": true, "isLabelChanged": false }
        ]
    },
    {
        "groupId": 17,
        "fields": [
            { "name": "userDefinedReference1", "tableName": "WMRATESCHEDULEHEADER", "label": "Reference 1", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "userDefinedReference2", "tableName": "WMRATESCHEDULEHEADER", "label": "Reference 2", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "userDefinedReference3", "tableName": "WMRATESCHEDULEHEADER", "label": "Reference 3", "type": "text", "required": false, "visible": true, "isLabelChanged": false }
        ]
    },
    {
        "groupId": 18,
        "fields": [
            { "name": "userDefinedReference4", "tableName": "WMRATESCHEDULEHEADER", "label": "Reference 4", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "userDefinedReference5", "tableName": "WMRATESCHEDULEHEADER", "label": "Reference 5", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "userDefinedReference6", "tableName": "WMRATESCHEDULEHEADER", "label": "Reference 6", "type": "text", "required": false, "visible": true, "isLabelChanged": false }
        ]
    },
    {
        "groupId": 19,
        "fields": [
            { "name": "userDefinedReference7", "tableName": "WMRATESCHEDULEHEADER", "label": "Reference 7", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "userDefinedReference8", "tableName": "WMRATESCHEDULEHEADER", "label": "Reference 8", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "userDefinedReference9", "tableName": "WMRATESCHEDULEHEADER", "label": "Reference 9", "type": "text", "required": false, "visible": true, "isLabelChanged": false }
        ]
    },
    {
        "groupId": 20,
        "fields": [
            { "name": "userDefinedReference10", "tableName": "WMRATESCHEDULEHEADER", "label": "Reference 10", "type": "text", "required": false, "visible": true, "isLabelChanged": false }
        ]
    }
];

export const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RECORD",
                "localizedField": "KEYSEQUENCE",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_PROFILECODE",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Profile",
                "type": "lookup",
                "layout": WMRateScheduleDpLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "SCHEDULECODE",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Code",
                "type": "text",
                "required": true,
                "maxLength": 10,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "SCHEDULETYPE",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Type",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "DESCRIPTION",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Description",
                "type": "text",
                "required": false,
                "maxLength": 40,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_CUSTOMER",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Customer",
                "type": "lookup",
                "layout": IDCustomerLookupLayout(),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ITEMCLASS",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Item Class",
                "type": "lookup",
                "layout": classCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ITEMSUBCLASS",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Item Sub Class",
                "type": "lookup",
                "layout": subClassCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    }
];

export const UserDefinedCodesLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDCODE1",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Code 1",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '47' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE2",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Code 2",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '48' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE3",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Code 3",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '49' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE4",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Code 4",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '50' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE5",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Code 5",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '51' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE6",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Code 6",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '52' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE7",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Code 7",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '53' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE8",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Code 8",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '54' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE9",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Code 9",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '55' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE10",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Code 10",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '56' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDDATE1",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Date 1",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE2",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Date 2",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE3",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Date 3",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE4",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Date 4",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE5",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Date 5",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE6",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Date 6",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE7",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Date 7",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE8",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Date 8",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE9",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Date 9",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE10",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Date 10",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDQUANTITY1",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Quantity 1",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY2",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Quantity 2",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY3",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Quantity 3",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY4",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Quantity 4",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY5",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Quantity 5",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY6",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Quantity 6",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY7",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Quantity 7",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY8",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Quantity 8",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY9",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Quantity 9",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY10",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Quantity 10",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    }
];

export const UserDefinedReferencesLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDREFERENCE1",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Reference 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE2",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Reference 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE3",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Reference 3",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE4",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Reference 4",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE5",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Reference 5",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE6",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Reference 6",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE7",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Reference 7",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE8",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Reference 8",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE9",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Reference 9",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE10",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Reference 10",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDCOMMENT",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Comment",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    }
];

export const MinimumsLayout = [
    {
        "groupId": 1,
        "label": "Apply",
        "fields": [
            {
                "name": "APPLY_RECEIPT",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Receipt",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "APPLY_SHIPMENT",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Shipment",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            
        ]
    },
    {
        "groupId": 2,
        "label": "Charge Code",
        "fields": [
        
            {
                "name": "R_CHARGE_RECEIPT",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Receipt Charge Code",
                "type": "lookup",
                "layout": WMChargeCodeLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_CHARGE_SHIPMENT",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Shipment Charge Code",
                "type": "lookup",
                "layout": WMChargeCodeLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            
        ]
    },
    {
        "groupId": 3,
        "label": "Minimum Amount",
        "fields": [
            {
                "name": "MINIMUMAMOUNT_RECEIPT",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Minimum Amount Receipt",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "MINIMUMAMOUNT_SHIPMENT",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Minimum Amount Shipment",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    }
];

export const AdditionalLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "SCHEDULEAPPLY",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Apply",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "STATUS",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "POPUPMESSAGE",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Popup Msg",
                "type": "lookup",
                "layout": ABPopupMessageLayout({ tableName: 'WMRATESCHEDULEHEADER' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "COMMENT",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Comment",
                "type": "text",
                "required": false,
                "maxLength": 40,
                "visible": true,
                "isLabelChanged": false,
            } 
        ]
    },
    {
        "groupId": 1,
        "label": "Storage End Date Methods",
        "fields": [
            {
                "name": "LOTSTORAGEENDDATE",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Lot",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "SUBLOTSTORAGEENDDATE",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Sublot",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RECURRINGSTORAGE",
                "tableName": "WMRATESCHEDULEHEADER",
                "label": "Recurring Flag",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    }
];
